import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link active",
      id: "home-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#home-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "home-tab-pane",
      "aria-selected": "true"
    }, "Information générale")
  ])
], -1)
const _hoisted_4 = {
  class: "tab-content",
  id: "myTabContent "
}
const _hoisted_5 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Arrondissement "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Mandatures "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h5", null, "Liste des quartiers :", -1)
const _hoisted_15 = { class: "row g-2" }
const _hoisted_16 = ["id"]
const _hoisted_17 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"600px"}
}
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header justify-content-center text-center border-0" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    style: {"text-decoration":"underline"}
  }, "Formulaire d'ajout d'un membre")
], -1)
const _hoisted_20 = { class: "modal-body" }
const _hoisted_21 = { class: "row justify-content-center" }
const _hoisted_22 = { class: "col-md-8 mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nom :", -1)
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "col-md-8 mb-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Prénom :", -1)
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { class: "col-md-8 mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Image :", -1)
const _hoisted_30 = ["onInput"]
const _hoisted_31 = { class: "modal-footer justify-content-center" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Annuler", -1)
const _hoisted_34 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_35 = ["data-bs-target", "onClick"]
const _hoisted_36 = { class: "d-flex flex-column gap-1" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-12" }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Modifier ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "assignationForm",
        onSubmit: _ctx.submitAssign,
        "validation-schema": _ctx.assignationSchema
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Field, { name: "arrondissements" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.arrondissementOptions,
                          searchable: true,
                          multiple: "false",
                          "data-mode": "arrondissements",
                          "track-by": "value",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Sélectionner l'arrondissement",
                          onChange: _ctx.onArrondissementChange
                        }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "arrondissements",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_Field, { name: "mandatures" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.mandaturesOptions,
                          searchable: true,
                          multiple: "false",
                          "data-mode": "mandatures",
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner la mandature" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "mandatures",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              (_ctx.quartiers?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quartiers, (quartier) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: quartier.id,
                          class: "col-md-6"
                        }, [
                          _createElementVNode("div", {
                            class: "modal fade",
                            id: `addMemberModal_${quartier.id}`,
                            tabindex: "-2",
                            "aria-hidden": "true"
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _hoisted_23,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        "onUpdate:modelValue": ($event: any) => ((quartier.membre.nom) = $event),
                                        placeholder: "Entrez un nom"
                                      }, null, 8, _hoisted_24), [
                                        [_vModelText, quartier.membre.nom]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                      _hoisted_26,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        "onUpdate:modelValue": ($event: any) => ((quartier.membre.prenom) = $event),
                                        placeholder: "Entrez un prénom"
                                      }, null, 8, _hoisted_27), [
                                        [_vModelText, quartier.membre.prenom]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _hoisted_29,
                                      _createElementVNode("input", {
                                        type: "file",
                                        class: "form-control",
                                        onInput: (e)=>_ctx.onImageChange(quartier, e)
                                      }, null, 40, _hoisted_30)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-primary",
                                      onClick: ($event: any) => (_ctx.addNewMembre(quartier))
                                    }, "Ajouter le membre", 8, _hoisted_32),
                                    _hoisted_33
                                  ])
                                ])
                              ])
                            ])
                          ], 8, _hoisted_16),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("strong", null, _toDisplayString(quartier.libelle), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-warning align-self-start",
                              style: {"color":"white","font-size":"10px"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": `#addMemberModal_${quartier.id}`,
                              onClick: ($event: any) => (_ctx.currentQuartierId = quartier.id)
                            }, " + Ajouter un membre ", 8, _hoisted_35)
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_Multiselect, {
                              options: _ctx.membresOptions,
                              searchable: true,
                              multiple: false,
                              "data-mode": "membres",
                              "track-by": "value",
                              label: "label",
                              modelValue: quartier.selectedMembre,
                              "onUpdate:modelValue": ($event: any) => ((quartier.selectedMembre) = $event),
                              placeholder: "Sélectionner un membre"
                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "membres",
                              class: "text-danger"
                            })
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createVNode(_component_router_link, {
                  to: "/liste-chefquartier",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_41,
                    _hoisted_42,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}